import { render, staticRenderFns } from "./SubfolderSearch.vue?vue&type=template&id=62965c2a&scoped=true"
import script from "./SubfolderSearch.vue?vue&type=script&lang=js"
export * from "./SubfolderSearch.vue?vue&type=script&lang=js"
import style0 from "./SubfolderSearch.vue?vue&type=style&index=0&id=62965c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62965c2a",
  null
  
)

export default component.exports